import { types, flow } from 'mobx-state-tree';
import { utils } from '@myplay/all';

const CategoriesStore = types
  .model({
    categories: types.array(types.frozen({}))
  })
  .actions(self => ({
    getCategories: flow(function* getCategories() {
      try {
        const categories = yield utils.getCategories();
        self.categories = [...categories];
      } catch (error) {
        console.log(error);
      }
    }), 
    getCategoryByName(name) {
      const category = self.categories.filter(cat => cat.name === name)[0];
      return category;
    }, 
    getCategoryById(id) {
      const category = self.categories.filter(cat => cat._id === id)[0];
      return category;
    }
  }));

export default CategoriesStore;